import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
    {
        path: '/',
        redirect: '/home'
    }, {
        path: '/home',
        name: 'home',
        component: () => import('../views/homePage.vue')
    }, {
        path: '/service',
        name: 'loanService',
        component: () => import('../views/loanService.vue')
    }, {
        path: '/about',
        name: 'aboutUS',
        component: () => import('../views/aboutUS.vue')
    }, {
        path: '/contact',
        name: 'contactUS',
        component: () => import('../views/contactUS.vue')
    }, {
        path: '/privatePolicySanjviv',
        name: 'privatePolicySanjviv',
        component: () => import('../views/privatePolicySanjviv.vue')
    }, {
        path: '/loanAgreementSanjviv',
        name: 'loanAgreementSanjviv',
        component: () => import('../views/loanAgreementSanjviv.vue')
    }, {
        path: '/privatePolicyNidhiNow',
        name: 'privatePolicyNidhiNow',
        component: () => import('../views/privatePolicyNidhiNow.vue')
    }, {
        path: '/loanAgreementNidhiNow',
        name: 'loanAgreementNidhiNow',
        component: () => import('../views/loanAgreementNidhiNow.vue')
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router;
